import React, {Fragment} from 'react';
import {GUTTER_SM, MARGIN_MD, MODAL_WIDTH_XL} from "../../../styles/constants";
import EnhancedModal from '../../../components/enhanced-modal';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {
  changeHierarchicalCodelistsHierarchicalCodelistDetail,
  hideHierarchicalCodelistsHierarchicalCodelistDetail,
  readHierarchicalCodelistsAgencies,
  readHierarchicalCodelistsHierarchicalCodelistDetail,
  showHierarchicalCodelistsHierarchicalCodelistClone,
  showHierarchicalCodelistsHierarchicalCodelistDownload,
  showHierarchicalCodelistsHierarchicalCodelistExport,
  submitHierarchicalCodelistsHierarchicalCodelistDetail
} from "./actions";
import {Alert, Button, Col, Modal, Row} from "antd";
import ArtefactForm, {
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import {isArtefactValid} from "../../../utils/artefactValidators";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";

const mapStateToProps = state => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  permissions: state.app.user.permissions,
  appLanguage: state.app.language,
  isVisible: state.scenes.metaManager.hierarchicalCodelists.isVisible,
  hierarchicalCodelistTriplet: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistTriplet,
  hierarchicalCodelist: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,
  agencies: state.scenes.metaManager.hierarchicalCodelists.agencies,
});

const mapDispatchToProps = dispatch => ({
  onHierarchicalCodelistDetailHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistDetail()),
  onHierarchicalCodelistDetailChange: fields => dispatch(changeHierarchicalCodelistsHierarchicalCodelistDetail(fields)),
  onHierarchicalCodelistDetailUpdate: (hierarchicalCodelist, annotationsConfig) => dispatch(submitHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelist, annotationsConfig)),
  fetchHierarchicalCodelist: hierarchicalCodelistTriplet => dispatch(readHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelistTriplet)),
  fetchAgencies: allowedAgencies => dispatch(readHierarchicalCodelistsAgencies(allowedAgencies)),
  onCloneShow: artefactTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet)),
  onDownloadShow: (hierarchicalCodelistTriplets, lang) => dispatch(showHierarchicalCodelistsHierarchicalCodelistDownload(hierarchicalCodelistTriplets, lang)),
});

const HierarchicalCodelistDetail = ({
                                      t,
                                      appLanguage,
                                      nodes,
                                      nodeId,
                                      permissions,
                                      isVisible,
                                      hierarchicalCodelistTriplet,
                                      hierarchicalCodelist,
                                      agencies,
                                      onHierarchicalCodelistDetailHide,
                                      onHierarchicalCodelistDetailChange,
                                      onHierarchicalCodelistDetailUpdate,
                                      fetchHierarchicalCodelist,
                                      fetchAgencies,
                                      onDownloadShow,
                                      onCloneShow,
                                      onExportShow
                                    }) => {

  const currentNode = nodes.find(node => node.general.id === nodeId);
  const annotationsConfig = currentNode.annotations;

  const userHasPermissionsToEdit = (
    permissions && hierarchicalCodelistTriplet &&
    permissions.agencies.filter(agency => agency === hierarchicalCodelistTriplet.agencyID).length > 0
  );

  return (
    <Call cb={fetchHierarchicalCodelist} cbParam={hierarchicalCodelistTriplet}
          disabled={!hierarchicalCodelistTriplet || hierarchicalCodelist !== null}>
      <Call cb={fetchAgencies} cbParam={permissions ? permissions.agencies : undefined}>
        <EnhancedModal
          visible={isVisible}
          width={MODAL_WIDTH_XL}
          title={userHasPermissionsToEdit
            ? t('scenes.metaManager.hierarchicalCodelists.detail.title.editMode.title', {triplet: hierarchicalCodelistTriplet})
            : t('scenes.metaManager.hierarchicalCodelists.detail.title.viewMode.title', {triplet: hierarchicalCodelistTriplet})
          }
          onCancel={onHierarchicalCodelistDetailHide}
          footer={
            <div>
              <Button
                onClick={onHierarchicalCodelistDetailHide}>{t('commons.buttons.close.title')}</Button>
              {userHasPermissionsToEdit
                ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isArtefactValid(hierarchicalCodelist)) {
                        onHierarchicalCodelistDetailUpdate(hierarchicalCodelist, annotationsConfig);
                      } else {
                        Modal.warning({
                          title: t('commons.alerts.invalidForm.title'),
                          content: t('commons.alerts.invalidForm.content')
                        });
                      }
                    }}
                  >
                    {t("commons.buttons.save.title")}
                  </Button>
                )
                : null}
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const lang = dataLanguage || appLanguage;
              return (
                <Fragment>
                  {permissions && !userHasPermissionsToEdit && (
                    <Alert
                      type="warning"
                      showIcon
                      message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                    />
                  )}
                  <Row type="flex" gutter={GUTTER_SM} justify={"end"}
                       style={{marginBottom: MARGIN_MD}}>
                    <Col>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="download"
                        size="small"
                        title={t('commons.artefact.buttons.download.title')}
                        onClick={() => onDownloadShow([hierarchicalCodelistTriplet], lang)}
                      />
                    </Col>
                    {permissions && (
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="copy"
                          size="small"
                          title={t('commons.artefact.buttons.clone.title')}
                          onClick={() => onCloneShow(hierarchicalCodelistTriplet)}
                        />
                      </Col>
                    )}
                    <Col>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="export"
                        size="small"
                        title={t('commons.artefact.buttons.export.title')}
                        onClick={() => onExportShow(hierarchicalCodelistTriplet)}
                      />
                    </Col>
                  </Row>
                  {hierarchicalCodelist && (
                    <ArtefactForm
                      artefact={hierarchicalCodelist}
                      mode={userHasPermissionsToEdit ? ARTEFACT_FORM_MODE_EDIT : ARTEFACT_FORM_MODE_READ}
                      agencies={agencies}
                      onChange={onHierarchicalCodelistDetailChange}
                      isHierarchicalCodelist
                    />
                  )}
                </Fragment>
              );
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(HierarchicalCodelistDetail);



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/hierarchical-codelists/Detail.jsx